import { IIconBase } from '..'

const dropIcon = ({
  color = '#131523',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5158 3.68334C20.9158 3.21668 20.0825 3.21668 19.4825 3.68334C16.3158 6.10001 6.96582 13.9833 7.01582 23.1667C7.01582 30.6 13.0658 36.6667 20.5158 36.6667C27.9658 36.6667 34.0158 30.6167 34.0158 23.1833C34.0325 14.1333 24.6658 6.11668 21.5158 3.68334Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export default dropIcon
